import * as React from 'react';
import { i18n } from '../../../i18n/i18n';

export function getHeaderElement(entity: string, att: any, showEntitiesInHeader?: boolean) {
    return (<div>
        <div
            style={{ height: '50px' }}
        >
            {showEntitiesInHeader && att.entity && <span style={{ fontSize: '10px', color: '#999' }}>{i18n(att.entity.TITEL, `entity.${entity}`)}<br /></span>}
            {showEntitiesInHeader && att.TYPE === 'FORMULA' && <span style={{ fontSize: '10px', color: '#999' }}>{i18n('Formel', 'sys')}<br /></span>}
            {showEntitiesInHeader && att.TYPE === 'FIX' && <span style={{ fontSize: '10px', color: '#999' }}>{i18n('Festwert', 'sys')}<br /></span>}
            {i18n(att.NAME_TABLE ? att.NAME_TABLE : att.NAME, `entity.${entity}`)}
        </div>
        {getHeaderAddon(att)}
        {getFormulaAddon(att)}
    </div>);
}

export function getHeaderText(entity: string, att: any) {
    if (att.AGGREGATE) {
        return att.NAME_TABLE ? att.NAME_TABLE : att.NAME + ' [' + getAggregationName(att.AGGREGATE) + ']';
    }
    return i18n(att.NAME, `entity.${entity}`);
}

function getHeaderAddon(att: any) {
    if (att.AGGREGATE) {
        return (<div
            style={{ backgroundColor: '#6688AA', textAlign: 'center', padding: '2px', marginTop: '3px' }}
        >
            {i18n(getAggregationName(att.AGGREGATE), 'sys')}
        </div>);
    }
    return '';
}

function getFormulaAddon(att: any) {
    if (att.FORMULA) {
        return (<div
            style={{ backgroundColor: '#6688AA', textAlign: 'center', padding: '2px', marginTop: '3px' }}
        >
            {i18n('Berechnet', 'sys')}
        </div>);
    }
    return '';
}

export function getAggregationName(key: string) {
    switch (key) {
        case 'SUM':
            return 'Summe';
        case 'CONCAT':
            return 'Konkat.';
        case 'COUNT':
            return 'Anzahl';
        case 'COUNT_DISTINCT':
            return 'Anzahl (unterschiedlich)';
        case 'COUNT_POSITIV':
            return 'Anzahl (Ja/>0/Wahr)';
    }
    return '? ' + key + ' ?';
}
